import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { emptyArray } from 'ui-components/default-props/empty';

const messages = defineMessages({
  failedToFetchActiveClientsMessage: {
    description: '3PL Provider Bundle Remove Bundle Modal Failed to Fetch Error Message',
    defaultMessage: 'An error occurred while determining whether or not your account has any active Clients.',
    id: 'KqUMUG',
  },
  assistedRemovalForPendingInviteCancellationFailure: {
    description:
      '3PL Provider Bundle Remove Bundle Modal Remove Via Support Due to A Failure on Our Part During the Cancellation of Pending Client Invitations',
    defaultMessage:
      'Our attempt at cancelling your pending {clientName, select, undefined {client invitations} other {invitation for client "{clientName}"}} failed.',
    id: 'YjAtlR',
  },
  assistedRemovalForActiveClient: {
    description: '3PL Provider Bundle Remove Bundle Modal Remove Via Support Due to Active Clients',
    defaultMessage: 'Our records indicate you currently have {clientCount} connected {clientCount, plural, one {Client} other {Clients}}.',
    id: 'Zp+fXL',
  },
});

const getSurvivingPendingClientName = (removalError, pendingClients) => {
  const erroredExternalInviteId = removalError.ErrorContext?.pendingInvitationCancellation.externalInviteId;
  const survivingPendingClient = pendingClients.find(({ externalInviteId }) => externalInviteId === erroredExternalInviteId);
  return survivingPendingClient?.clientName;
};

const ErrorHeader = ({
  activeClientCount = null,
  didErrorFetchingClientData = false,
  pendingClients = emptyArray,
  removalError = null,
}) => {
  if (!activeClientCount && !didErrorFetchingClientData && !removalError) {
    return null;
  }

  const getMessageToDisplay = () => {
    if (didErrorFetchingClientData) {
      return <FormattedMessage {...messages.failedToFetchActiveClientsMessage} />;
    }
    if (removalError) {
      return (
        <FormattedMessage
          {...messages.assistedRemovalForPendingInviteCancellationFailure}
          values={{
            clientName: getSurvivingPendingClientName(removalError, pendingClients),
          }}
        />
      );
    }
    if (activeClientCount) {
      return <FormattedMessage {...messages.assistedRemovalForActiveClient} values={{ clientCount: activeClientCount }} />;
    }
  };

  return <BannerMessageV2 content={getMessageToDisplay()} status={BannerStatus.Error} />;
};

ErrorHeader.propTypes = {
  activeClientCount: PropTypes.number,
  didErrorFetchingClientData: PropTypes.bool,
  removalError: PropTypes.shape({
    Code: PropTypes.string,
    ErrorContext: PropTypes.shape({
      pendingInvitationCancellation: PropTypes.shape({
        didCancel: PropTypes.bool,
        externalInviteId: PropTypes.string,
      }),
    }),
    Level: PropTypes.string,
    Message: PropTypes.string,
  }),
  pendingClients: PropTypes.array,
};

export default ErrorHeader;
